'use client';

import useVillageContext from '@/hooks/useVillageContext';

export default function DatePickerSucessMessage() {
  const {calendarPromotionTitle} = useVillageContext();

  return (
    calendarPromotionTitle && (
      <div className="text-sm md:text-base relative w-full min-h-[55px]">
        <p className="text-white bg-[#5ac864] text-center py-[5px] px-[15px] mt-[5px]">
          {calendarPromotionTitle}
        </p>
      </div>
    )
  );
}
